import React from 'react';
import ButtonsRectangular from "../../Components/ButtonsRectangular";
import store from "../../js/store";
import { connect } from "react-redux";
import { loadSection } from "../../js/actions/index";
import axios from "axios";
import config from "../../config/config";
import {bodyGet} from "../../utils/utils";
import {loadForm} from "../../js/actions";
import Button from "@material-ui/core/Button";
import {Link} from "react-router-dom";
import List from "@material-ui/core/List";
import CardMenu from "../../Components/CardMenu";
import Container from "@material-ui/core/Container";


class MenuRepository extends React.Component {
  constructor(props) {
    super(props);
    this.state = { file: { children:[] }};
  }

  // componentDidUpdate(prevProps) {
  //   // // Uso tipico (no olvides de comparar los props):
  //   // if (this.props.files !== prevProps.files) {
  //   //   this.setState({files: this.props.files})
  //   // }
  // }

  componentWillMount() {
    this.getFile();
  }

  getFile(){
    const idFile = this.props.fileId;
    //get all url
    console.log("params", this.props);
    return axios.post("https://www.sspa.juntadeandalucia.es/servicioandaluzdesalud/hhuuvr/innovacion/app/folder", {ruta: idFile})
        .then(res => {
            console.log(res);
            this.setState({file:res.data})
          return res;
        })
        .catch(err => {
          console.log('Error:', err);
          localStorage.removeItem('token_patient');
          this.props.history.push(this.getRoute('/login'));
          return null;
        })
  }

  getRoute = (path, query='') => `${path}${!query ? '' : `?${query}`}`;

  getPropsButtonsRectangular = (file) => {
      const properties = {
          text:file.name,
          data:file,
          colorIcon:'',
          icon: !file.icon ? 'ic_clear':file.icon,
          href: !file.href ? '' : this.getRoute(file.href)
      };
      return properties
  }


  render() {

    return (
      <Container maxWidth="sm">
        <div style={{paddingTop: "24px"}}>

          {
            // this.state.file.children.map((file, index) =>
            //     <ButtonsRectangular
            //         key={`file-${index}`}
            //         id={index}
            //         {...this.getPropsButtonsRectangular(file)}
            //     />
            // )

            this.state.file.children.map((button, index) => {
              console.log(button)
              // El backend devuelve en `href` la ruta completa desde la raíz del repositorio
              // (ej. "welcome/PERSONAL SANITARIO"), pensada para usarse tal cual como `ruta`
              // de la siguiente petición. Hay que anteponer "/repository/" para obtener una
              // ruta absoluta de la app: si se deja relativa, el navegador la resuelve
              // respecto al directorio de la URL actual y duplica el prefijo en cada nivel.
              const isExternal = button.href && button.href.substr(0, 4) === "http";
              const redirect = isExternal ? button.href : `/repository/${button.href}`;
              return <CardMenu
                key={`button${index}`}
                ref={`button${index}`}
                history={this.props.history}
                description={button.name}
                redirect={redirect}
                app={this.props.app}
                {...button}/>
            })

          }
        </div>
      </Container>
    );
  }
}

function mapStateToProps(state, props) {
  return {
      fileId: props.match.params.id
  };
}
function mapDispatchToProps(dispatch) {
  return {};
}

const defaultFiles = {
      name:'Root',
      children:[
            {
                name:'Primera carpeta',
                icon:'',
                color:'yellow',
                href:'/files/2'
            },
            {
                name:'Vídeo',
                icon:'ic_play_arrow',
                color:'red',
                href:'/video'
            },
            {
                name:'Documento',
                icon:'ic_play_arrow',
                color:'red',
                href:'/document/12'
            },
            {
                name:'PDF',
                icon:'',
                color:'green'
            },
            {
                name:'Texto',
                icon:'',
                color:'blue'
            }
        ]
  };

export default connect(mapStateToProps, mapDispatchToProps)(MenuRepository);
